export function formatSex(sex: string): string {
  switch (sex) {
    case 'male': return 'Male'
    case 'female': return 'Female'
    case 'intersex': return 'Intersex'
    case 'prefer_not_to_say': return 'Prefer not to say'
    default: return sex
  }
}

export function formatGender(gender: string): string {
  switch (gender) {
    case 'man': return 'Man'
    case 'woman': return 'Woman'
    case 'non_binary': return 'Non-binary'
    case 'transgender_man': return 'Transgender man'
    case 'transgender_woman': return 'Transgender woman'
    case 'other': return 'Other'
    case 'prefer_not_to_say': return 'Prefer not to say'
    default: return gender
  }
}

export function formatConditionCategory(category: string): string {
  return category
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export function formatVisitTypeCategory(category: string): string {
  switch (category) {
    case 'initial': return 'Initial'
    case 'follow_up': return 'Follow-Up'
    case 'refill': return 'Refill'
    default: return category
  }
}

export function formatCents(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

export function formatMonth(ym: string): string {
  const [year, month] = ym.split('-').map((n) => parseInt(n, 10))
  const date = new Date(year, month - 1, 1)
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
}
